module.exports = __webpack_public_path__ + "static/media/bus-icon-over.4ad59bff.svg";